import { LCDocumentEditorUtils } from './LCDocumentEditorUtils';
import { ILectioPlugin } from './Types';

export class PluginSetFocusWidgetFix implements ILectioPlugin {
	public Init(): void {
		////STM 29867 - Kunne ikke få adgang til Start-element inde i en widget (for slides) når der ikke aktivt var flyttet fokus ind
		CKEDITOR.on('instanceReady',
			eee => {
				for (const inst of LCDocumentEditorUtils.GetAllEditorInstances()) {
					inst.on('beforeCommandExec', evt => {
						const selection = evt.editor.getSelection();
						if (!selection)
							return;
						let element = selection.getStartElement();
						if (!element) {
							element = evt.editor.editable()!.findOne('h1');
							if (!element) {
								const last = evt.editor.editable()!.getLast();
								if (!(last instanceof CKEDITOR.dom.element))
									throw new Error('er ikke element?');
								element = last;
							}
							const range = evt.editor.createRange();
							range.setStart(element, 0);
							range.setEnd(element, 0);
							selection.selectRanges([range]);
						}
					});
				}
			});
	}
}
